












































































import {
  computed, ref, defineComponent, PropType, onMounted, watch,
} from '@vue/composition-api';
import FCImage from '~/components/FCImage.vue';
import { FCButton } from '@fc/angie-ui';
import { IStoryblokMedia } from '~/selectors/types';
import { useModal } from '~/composables/useModal';
import { isMobileEffect } from '~/effects/matchMedia';

export interface IReviewGalleryProps {
  component: 'ReviewGallery';
  codeId: string;
  title: string;
  images: IStoryblokMedia[];
}

export default defineComponent({
  name: 'ReviewGallery',
  components: {
    FCImage,
    FCButton,
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      required: false,
      default: 'Customer photos',
    },
    images: {
      type: Array as PropType<(IStoryblokMedia | undefined)[]>,
      default: () => [],
    },
  },
  setup(props: IReviewGalleryProps) {
    const isMobile = isMobileEffect();
    // Use a ref for sliceAmount to avoid SSR/client hydration mismatch
    // Default to 12 for SSR, then adjust on client after mount
    const sliceAmount = ref(12);
    const showAll = ref(false);
    const firstImages = computed(() => props.images?.slice(0, sliceAmount.value));
    const remainingImages = computed(() => props.images?.slice(sliceAmount.value, props.images.length));
    const areMoreImgs = computed(() => props.images?.length > sliceAmount.value);
    const imagesValid = computed(() => props.images?.length > 0);

    // Adjust slice amount based on viewport after hydration
    onMounted(() => {
      sliceAmount.value = isMobile.value ? 4 : 12;
    });

    // Watch for viewport changes after initial mount
    watch(isMobile, (newValue) => {
      sliceAmount.value = newValue ? 4 : 12;
    });

    function toggleShowAllImages() {
      showAll.value = !showAll.value;
    }

    return {
      areMoreImgs,
      firstImages,
      remainingImages,
      toggleShowAllImages,
      showAll,
      openModal(image: IStoryblokMedia) {
        if (image && image?.filename) {
          const maxWidth = Math.min(500, Math.floor(window.innerWidth * 0.85));
          const maxHeight = Math.min(700, Math.floor(window.innerHeight * 0.85));

          const { modalShow } = useModal({
            component: () => import('~/components/storyblok/ImageModal/ImageModal.vue'),
            componentProps: image,
            modalProps: {
              componentName: 'ImageModal',
              maxWidth,
              maxHeight,
            },
          });

          modalShow();
        }
      },
      imagesValid,
      getShowCopy: computed(() => (showAll.value ? 'See less' : 'See all')),
    };
  },
});
